import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import './TermsOfServiceHero.css';

const TermsOfServiceHero = () => {
  return (
    <Box className="terms-hero">
      <div className="terms-hero-overlay" />
      <Container maxWidth="lg" sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <motion.div
          className="terms-hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="subtitle1"
            className="terms-hero-subtitle-top"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Please Read Carefully
          </Typography>
          <Typography
            variant="h1"
            className="terms-hero-title"
            component={motion.h1}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            TERMS OF SERVICE
          </Typography>
          <Typography
            className="terms-hero-description"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            These Terms of Service govern your use of the Virves Software Solutions website and services. Please review them carefully before using our platform.
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default TermsOfServiceHero; 